import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight, ExternalLink, Heart } from 'lucide-react';
interface ProjectCardProps {
  title: string;
  description: string;
  category: string;
  thumbnailColor: string;
  likes: number;
  index: number;
}
export function ProjectCard({
  title,
  description,
  category,
  thumbnailColor,
  likes,
  index
}: ProjectCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    delay: index * 0.05,
    duration: 0.5
  }} className="group flex items-center gap-4 md:gap-6 p-4 md:p-6 rounded-2xl hover:bg-neutral-50 transition-colors cursor-pointer border border-transparent hover:border-neutral-100" data-id="element-57">
      {/* Thumbnail */}
      <div className={`w-12 h-12 md:w-16 md:h-16 rounded-lg ${thumbnailColor} flex-shrink-0 flex items-center justify-center text-white font-bold text-xl shadow-sm`} data-id="element-58">
        {title.charAt(0)}
      </div>

      {/* Content */}
      <div className="flex-1 min-w-0" data-id="element-59">
        <div className="flex items-center gap-2 mb-1" data-id="element-60">
          <h3 className="text-base md:text-lg font-semibold text-neutral-900 truncate" data-id="element-61">
            {title}
          </h3>
          <span className="hidden sm:inline-block px-2 py-0.5 rounded-full bg-neutral-100 text-neutral-500 text-xs font-medium" data-id="element-62">
            {category}
          </span>
        </div>
        <p className="text-sm md:text-base text-neutral-500 truncate pr-4" data-id="element-63">
          {description}
        </p>
        <span className="sm:hidden inline-block mt-2 px-2 py-0.5 rounded-full bg-neutral-100 text-neutral-500 text-xs font-medium" data-id="element-64">
          {category}
        </span>
      </div>

      {/* Actions */}
      <div className="flex items-center gap-3 md:gap-6" data-id="element-65">
        {/* Upvote/Like Counter (Visual) */}
        {/* <div className="flex flex-col items-center justify-center min-w-[3rem] md:min-w-[4rem] h-12 md:h-14 border border-neutral-200 rounded-lg group-hover:border-neutral-300 bg-white transition-colors">
          <Heart className="w-3 h-3 md:w-4 md:h-4 text-neutral-400 mb-1 group-hover:text-red-500 transition-colors" />
          <span className="text-xs font-medium text-neutral-600">{likes}</span>
         </div> */}

        {/* Visit Button */}
        <button className="hidden md:flex items-center justify-center w-10 h-10 rounded-full border border-neutral-200 text-neutral-400 hover:text-neutral-900 hover:border-neutral-900 transition-all" data-id="element-66">
          <ExternalLink className="w-4 h-4" data-id="element-67" />
        </button>
      </div>
    </motion.div>;
}